// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');

// @ constants
const actionTypes = require('constants/actionTypes');
const {
    NOT_ALLOWED_PRODUCT_CONTRACT_TNC_EMAIL_COUNTRIES,
} = require('constants/flagBasedFeatures');

const sendPreContractualDocumentMailRequest = () => ({
    type: actionTypes.SEND_PRECONTRACTUAL_DOCUMENT_MAIL_REQUEST
});

const sendPreContractualDocumentMailSuccess = () => ({
    type: actionTypes.SEND_PRECONTRACTUAL_DOCUMENT_MAIL_SUCCESS
});

const sendPreContractualDocumentMailFailure = (error) => ({
    type: actionTypes.SEND_PRECONTRACTUAL_DOCUMENT_MAIL_ERROR,
    payload: {
        error,
    }
});

const resetPrecontractualDocumentMail = () => ({
    type: actionTypes.SEND_PRECONTRACTUAL_DOCUMENT_MAIL_RESET
});

const sendPrecontractualDocumentMail = (precontractualMailProductInfo, forceEmailSending, forceV2PrecontractualDocumentMailEndpoint) => (dispatch, getState) => {
    const isProductContractEmailEnabled = getState().flagBasedFeatures.get(NOT_ALLOWED_PRODUCT_CONTRACT_TNC_EMAIL_COUNTRIES);
    const isMailSent = getState().precontractualDocumentMailer.get('mailSent');

    let requestData = {
        query: precontractualMailProductInfo,
    };

    if (precontractualMailProductInfo.hasOwnProperty('productsRelated') || forceV2PrecontractualDocumentMailEndpoint) {
        requestData.header = {
            version: 2,
        };
    }

    // 1st we check the feature flag and only if it's turned on we continue with the logic.
    // If forceEmailSending is true we send the email. That flag is set to true for promotion codes in Checking and Payroll Accounts (for example)
    // If we're in Contact Center the email is sent manually in the first step, so there's no need to send it automatically here
    // If the email was already sent for this operative we don't send it again (going back and forth one or more steps).
    if (isProductContractEmailEnabled && (forceEmailSending || (!__CONTACT_CENTER__ && !isMailSent))) {
        dispatch(sendPreContractualDocumentMailRequest());

        return APIPost({
            dispatch,
            endpoint: 'sendPrecontractualDocumentMail',
            params: requestData
        })
        .then(() => {
            dispatch(sendPreContractualDocumentMailSuccess());
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(sendPreContractualDocumentMailFailure(response.error));
            } else {
                throw response;
            }
        });
    }
};

module.exports = {
    resetPrecontractualDocumentMail,
    sendPrecontractualDocumentMail
};